// Central place to read environment variables at build-time.
// These will be replaced by the bundler during build.
export const OPENAI_API_KEY = "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";
export const DEEPSEEK_API_KEY = "sk-69d374216e6f4dcf9d2a5a94c6a93c63";
export const OPENROUTER_API_KEY = process.env.REACT_APP_OPENROUTER_API_KEY;

// Optional: allow overriding via localStorage at runtime (e.g., for dev/testing)
export const getOpenAIKey = () => OPENAI_API_KEY || (typeof window !== 'undefined' && localStorage.getItem('OPENAI_API_KEY')) || undefined;
export const getDeepSeekKey = () => DEEPSEEK_API_KEY || (typeof window !== 'undefined' && localStorage.getItem('DEEPSEEK_API_KEY')) || undefined;
export const getOpenRouterKey = () => OPENROUTER_API_KEY || (typeof window !== 'undefined' && localStorage.getItem('OPENROUTER_API_KEY')) || undefined;

